import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CtxForm } from '../../../_forms/models/form.model';
import { environment } from 'utils';
import { Router, RouterLink } from '@angular/router';
import { AuthnService } from '../../../_services/authn.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CtxAlertComponent } from '../../alert/alert.component';
import { CtxButtonComponent } from '../../button/button.component';
import { GoogleSsoComponent } from '../../google-sso/google-sso.component';
import { MatInputModule } from '@angular/material/input';
import { HlmIconComponent } from '../../icon';

@Component({
  selector: 'ctx-customer-login',
  templateUrl: './customer-login.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    CtxAlertComponent,
    CtxButtonComponent,
    HlmIconComponent,
    GoogleSsoComponent,
    RouterLink,
    FormsModule,
  ],
})
export class CustomerLoginComponent extends CtxForm implements OnInit {
  constructor(
    private fb: FormBuilder,
    private authnService: AuthnService,
    private router: Router
  ) {
    super();
  }

  environment = environment;
  ngOnInit(): void {
    this.formGroup = this.fb.group({
      accountAlias: [''],
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  /**
   * Performs login based on credentials entered in the form.
   */
  override async submit(): Promise<void> {
    if (this.formGroup.invalid) {
      return;
    } else {
      try {
        this._startFormSubmission();
        let response: any;
        if (environment.get('name') === 'local') {
          response = await this.authnService.login({
            ...this.formGroup.value,
          });
        } else {
          const formValue = Object.assign({}, this.formGroup.value);
          formValue.accountAlias = await this.authnService.getAccountAlias();
          response = await this.authnService.login({
            ...formValue,
          });
        }
        await this.authnService.checkUserRole();
        this._afterSubmissionSuccess(response);
      } catch (errorResponse) {
        this.handleTwoFactorError(errorResponse);
        this._handleFormError(errorResponse);
      }
      this._endFormSubmission();
    }
  }
  handleTwoFactorError(errorResponse: any) {
    if (
      errorResponse &&
      errorResponse.error &&
      errorResponse.error.code &&
      errorResponse.error.code === 'MISSING_TWO_FACTOR_CODE'
    ) {
      this.setCustomApiMessage({
        alertLevel: 'success',
        text: 'Login successful, redirecting to Two Factor Authentication.',
      });
      this.router.navigate(['auth/two-factor']);
    }
  }
  async initSsoLogin() {
    this.setState('sso', true);
    this.formGroup.disable();
    this.authnService
      .initSsoLogin(await this.authnService.getAccountAlias())
      .then()
      .catch((errorResponse) => {
        this.setApiMessage(errorResponse);
        this.setState('sso', false);
        this.formGroup.enable();
      });
  }
}
